import React, { useState } from 'react';

const Contact = () => {
  const handleCall = () => {
    window.open('tel:+251956445555');
  };

  const handleEmail = () => {
    window.open('mailto:Ermiyasbedasa4@gmail.com');
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/251909068030');
  };

  const copyContactInfo = () => {
    const contactText = `Ermiyas Bedasa\nEmail: Ermiyasbedasa4@gmail.com\nPhone: +251 956445555\nWhatsApp: 0909068030\nOffice: Bole, Millennium Hall front Little China - 1st Floor`;
    
    navigator.clipboard.writeText(contactText)
      .then(() => alert('Contact information copied to clipboard!'))
      .catch(() => alert('Failed to copy contact information.'));
  };

  // AUTHENTIC BRAND ICONS
  const PhoneIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="#25D366">
      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
    </svg>
  );

  const EmailIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="#EA4335">
      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
    </svg>
  );

  const WhatsAppIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="#25D366">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
  );

  const CopyIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="#4285F4">
      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
    </svg>
  );

  const FacebookIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="#1877F2">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  );

  const InstagramIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24">
      <defs>
        <radialGradient id="instagram-gradient" cx="0.3" cy="1" r="1.5">
          <stop offset="0%" stopColor="#fdf497" />
          <stop offset="5%" stopColor="#fdf497" />
          <stop offset="45%" stopColor="#fd5949" />
          <stop offset="60%" stopColor="#d6249f" />
          <stop offset="90%" stopColor="#285AEB" />
        </radialGradient>
      </defs>
      <path fill="url(#instagram-gradient)" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  );

  const TikTokIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="#FFFFFF">
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.06-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.9-.32-1.98-.23-2.81.36-.72.51-1.1 1.4-1.13 2.27-.01 1.01.46 2.04 1.28 2.63.73.54 1.68.74 2.58.55 1.05-.2 1.92-1.01 2.21-2.01.12-.44.17-.9.17-1.35V.02z"/>
    </svg>
  );

  const ClockIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="#f3b33d">
      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
    </svg>
  );

  return (
    <>
      <style>
        {`
          .contact {
            background: linear-gradient(135deg, #0a0f1c 0%, #0c1120 100%);
            min-height: auto !important;
            position: relative;
            overflow: hidden;
            padding: 3rem 1rem;
          }

          .contact-container {
            max-width: 1000px;
            margin: 0 auto;
            position: relative;
            z-index: 2;
          }

          .section-header {
            text-align: center;
            margin-bottom: 3rem;
          }

          .section-pre-title {
            color: #f3b33d;
            font-size: 0.8rem;
            text-transform: uppercase;
            letter-spacing: 0.2em;
            margin-bottom: 0.5rem;
            display: block;
            font-family: 'Comfortaa', cursive;
          }

          .section-header h2 {
            color: #ffffff;
            font-size: 2.2rem;
            font-family: 'Cormorant Garamond', serif;
          }

          .section-header .accent {
            color: #f3b33d;
          }

          .contact-card {
            background: rgba(255, 255, 255, 0.02);
            border-radius: 20px;
            padding: 3rem;
            border: 1px solid rgba(255, 255, 255, 0.08);
          }

          .profile-header {
            text-align: center;
            margin-bottom: 3rem;
          }

          .profile-avatar {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            background: linear-gradient(135deg, #f3b33d, #f6d69b);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.5rem;
            font-weight: 600;
            color: #062030;
            margin: 0 auto 1rem;
          }

          .profile-info h3 {
            font-size: 1.8rem;
            color: #ffffff;
            font-family: 'Cormorant Garamond', serif;
          }

          .profile-title {
            color: #f3b33d;
            font-size: 0.9rem;
            font-family: 'Comfortaa', cursive;
          }

          .office-hours-section {
            padding: 1rem 0;
            margin-bottom: 2.5rem;
          }

          .office-hours-section h4 {
            color: #ffffff;
            font-size: 1.1rem;
            margin-bottom: 1.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
          }

          .hours-grid {
            display: grid;
            grid-template-columns: 1fr; 
            gap: 0.8rem;
            max-width: 400px;
            margin: 0 auto;
          }

          .hour-item {
            display: flex;
            justify-content: space-between;
            padding: 0.8rem;
            background: rgba(255, 255, 255, 0.02);
            border-radius: 10px;
            white-space: nowrap; 
            gap: 20px;
          }

          .hour-day { color: #ffffff; font-size: 0.85rem; }
          .hour-time { color: #f3b33d; font-size: 0.85rem; }

          .actions-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 1rem;
            margin-bottom: 2.5rem;
          }

          .action-btn, .social-btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 0.8rem;
            padding: 1.2rem 0.8rem;
            background: transparent;
            border: none;
            color: #ffffff;
            font-size: 0.85rem;
            font-weight: 600;
            transition: all 0.3s ease;
            cursor: pointer;
            font-family: 'Comfortaa', cursive;
            text-decoration: none;
          }

          .action-btn:hover, .social-btn:hover {
            transform: translateY(-5px);
          }

          .social-section {
            padding: 1rem 0;
          }

          .social-section h4 {
            color: #ffffff;
            font-size: 1.1rem;
            margin-bottom: 1.5rem;
            text-align: center;
          }

          /* UPDATED: Horizontally arranged social grid */
          .social-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr); /* 3 columns side-by-side */
            gap: 1rem;
            max-width: 500px; /* Wider to accommodate horizontal icons */
            margin: 0 auto;
          }

          @media (max-width: 768px) {
            .actions-grid { grid-template-columns: repeat(2, 1fr); }
            /* Force side-by-side on mobile as well */
            .social-grid { 
                grid-template-columns: repeat(3, 1fr);
                gap: 0.5rem; 
            }
            .social-btn span { font-size: 0.75rem; }
            .hours-grid { grid-template-columns: 1fr; }
          }

          @media (max-width: 480px) {
            .actions-grid { grid-template-columns: repeat(2, 1fr); }
          }
        `}
      </style>

      <section className="contact" id="contact">
        <div className="contact-container">
          <div className="section-header">
            <span className="section-pre-title">Get In Touch</span>
            <h2>
              Let's <span className="accent">Connect</span>
            </h2>
          </div>

          <div className="contact-card">
            <div className="profile-header">
              <div className="profile-avatar">EB</div>
              <div className="profile-info">
                <h3>Ermiyas Bedasa</h3>
                <p className="profile-title">Professional Real Estate Advisor</p>
              </div>
            </div>

            <div className="office-hours-section">
              <h4><ClockIcon /> Office Hours</h4>
              <div className="hours-grid">
                <div className="hour-item">
                  <span className="hour-day">Mon - Fri</span>
                  <span className="hour-time">9:00 AM - 6:00 PM</span>
                </div>
                <div className="hour-item">
                  <span className="hour-day">Saturday</span>
                  <span className="hour-time">10:00 AM - 4:00 PM</span>
                </div>
                <div className="hour-item">
                  <span className="hour-day">Sunday</span>
                  <span className="hour-time">Closed</span>
                </div>
              </div>
            </div>

            <div className="actions-section">
              <div className="actions-grid">
                <button className="action-btn" onClick={handleCall}>
                  <PhoneIcon />
                  <span>Call Now</span>
                </button>
                <button className="action-btn" onClick={handleEmail}>
                  <EmailIcon />
                  <span>Send Email</span>
                </button>
                <button className="action-btn" onClick={handleWhatsApp}>
                  <WhatsAppIcon />
                  <span>WhatsApp</span>
                </button>
                <button className="action-btn" onClick={copyContactInfo}>
                  <CopyIcon />
                  <span>Copy Info</span>
                </button>
              </div>
            </div>

            <div className="social-section">
              <h4>Follow Me On Social Media</h4>
              <div className="social-grid">
                <a 
                  href="https://www.facebook.com/share/17aNgkt7ZM/?mibextid=wwXIfr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-btn"
                >
                  <FacebookIcon />
                  <span>Facebook</span>
                </a>
                <a 
                  href="https://www.instagram.com/jermii44?igsh=NWNlcnNmc29ocnpy&utm_source=qr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-btn"
                >
                  <InstagramIcon />
                  <span>Instagram</span>
                </a>
                <a 
                  href="https://www.tiktok.com/@ermiyas_realestate_advis?_r=1&_t=ZM-91fRwOskpsy" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-btn"
                >
                  <TikTokIcon />
                  <span>TikTok</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;